($ => {

    $('.Sidebar-scrollUp').click( function () {
        $('html, body').animate({scrollTop: 0}, 'slow')
    } )

})(jQuery)